import {
  drawerWidth,
  transition,
  container
} from "../../../jss/material-dashboard-react.js";

const appStyle = theme => ({
  wrapper: {
    position: "relative",
    top: "0",
    height: "100vh"
  },
  mainPanel: {
    [theme.breakpoints.up("md")]: {
      width: `calc(100% - ${drawerWidth}px)`
    },
    overflow: "auto",
    position: "relative",
    float: "right",
    ...transition,
    maxHeight: "100%",
    width: "100%",
    overflowScrolling: "touch"
  },
  content: { 
    padding: "15px 15px",
    paddingTop: "60px",
    minHeight: "calc(100vh - 60px)"
  },
  container,
  map: {
    marginTop: "70px"
  }
});

export default appStyle;
